export default __webpack_public_path__ + "static/media/Burger-Bun.105842dc.jpg";